import { render, staticRenderFns } from "./EventActionMenu.vue?vue&type=template&id=31117c60&scoped=true"
import script from "./EventActionMenu.vue?vue&type=script&lang=js"
export * from "./EventActionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31117c60",
  null
  
)

export default component.exports